/**
 * Quiz analytics forwarder (§11).
 *
 * The quiz element dispatches `twt:quiz-*` CustomEvents on `document` and does
 * not care who listens. This file is the only subscriber, and the only place
 * that knows about destinations. Keeping it separate means adding or removing a
 * destination never touches the quiz, and the quiz stays testable without one.
 *
 * Destinations:
 *  - window.dataLayer        (Google Tag Manager, if a container is installed)
 *  - Shopify.analytics.publish  (Shopify Web Pixels — a custom pixel subscribes
 *    with analytics.subscribe('twt_quiz_completed', ...) and can fan out to
 *    GA4, Meta, or an HTTP endpoint)
 *
 * Both are optional. If neither exists the events are simply dropped, which is
 * the correct behaviour for a store that has not configured analytics yet.
 */
(function () {
  'use strict';

  // Shopify custom pixel event names must be snake_case and are namespaced by
  // convention so they cannot collide with Shopify's own standard events.
  const EVENTS = {
    'twt:quiz-started': 'twt_quiz_started',
    'twt:quiz-step': 'twt_quiz_step',
    'twt:quiz-abandoned': 'twt_quiz_abandoned',
    'twt:quiz-completed': 'twt_quiz_completed',
    'twt:quiz-product-click': 'twt_quiz_product_click',
    'twt:quiz-add-to-cart': 'twt_quiz_add_to_cart',
    'twt:quiz-subscribed': 'twt_quiz_subscribed',
  };

  // The quiz merges its whole answer object into every event detail, which is
  // convenient in the browser but must not be shipped verbatim: `email` is in
  // there. Strip it at the boundary rather than trusting every destination.
  const DROP_KEYS = ['email'];

  function sanitize(detail) {
    const payload = {};
    Object.keys(detail || {}).forEach((key) => {
      if (DROP_KEYS.indexOf(key) !== -1) return;
      payload[key] = detail[key];
    });
    return payload;
  }

  function toDataLayer(name, payload) {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push(Object.assign({ event: name }, payload));
  }

  function toShopifyPixel(name, payload) {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    try {
      publish(name, payload);
    } catch (error) {
      /* a failing pixel must never break the quiz */
    }
  }

  Object.keys(EVENTS).forEach((domEvent) => {
    document.addEventListener(domEvent, (event) => {
      const name = EVENTS[domEvent];
      const payload = sanitize(event.detail);
      toDataLayer(name, payload);
      toShopifyPixel(name, payload);
    });
  });
})();
